var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmissionDashboardLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#FFBB38",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8568 19.0804C30.6306 18.9732 30.3694 18.9732 30.1432 19.0804L17.4869 25.0804C17.1821 25.2249 16.9909 25.5396 17.0003 25.8812C17.0098 26.2228 17.2181 26.5261 17.5304 26.653L30.1866 31.7958C30.3878 31.8776 30.6122 31.8776 30.8134 31.7958L40.625 27.8089V37.8571C39.693 37.8571 38.9375 38.6247 38.9375 39.5714V43H44V39.5714C44 38.6247 43.2445 37.8571 42.3125 37.8571V27.1232L43.4696 26.653C43.7819 26.5261 43.9902 26.2228 43.9997 25.8812C44.0091 25.5396 43.8179 25.2249 43.5131 25.0804L30.8568 19.0804ZM30.5 30.0768L19.9667 25.7966L30.5 20.803L41.0333 25.7966L30.5 30.0768Z",
    fill: "#FFBB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0463 31.0546C23.8268 30.971 23.5829 30.9839 23.3732 31.0902C23.1634 31.1966 23.0067 31.3868 22.9405 31.6153L22.0968 34.5296C21.974 34.9537 22.1889 35.4031 22.5929 35.5673L30.1866 38.653C30.3878 38.7347 30.6122 38.7347 30.8134 38.653L38.4071 35.5673C38.8111 35.4031 39.026 34.9537 38.9032 34.5296L38.0595 31.6153C37.9933 31.3868 37.8366 31.1966 37.6268 31.0902C37.4171 30.9839 37.1732 30.971 36.9537 31.0546L30.5 33.5131L24.0463 31.0546ZM23.9323 34.2652L24.3034 32.9834L30.2037 35.2311C30.3948 35.3039 30.6052 35.3039 30.7963 35.2311L36.6966 32.9834L37.0677 34.2652L30.5 36.934L23.9323 34.2652Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionDashboardLink);
export default __webpack_public_path__ + "static/media/admission-dashboard-link.1d40ba5525509e0ee8e4a7ff3e4bbb2b.svg";
export { ForwardRef as ReactComponent };